module.exports = __webpack_public_path__ + "img/32d3562.webp";